import { render, staticRenderFns } from "./IbAppDrawer.vue?vue&type=template&id=4c1199d5&scoped=true"
import script from "./IbAppDrawer.vue?vue&type=script&lang=js"
export * from "./IbAppDrawer.vue?vue&type=script&lang=js"
import style0 from "./IbAppDrawer.vue?vue&type=style&index=0&id=4c1199d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1199d5",
  null
  
)

export default component.exports